import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Routes, Route, } from "react-router-dom";
// import { useEffect } from 'react';
import Login from './components/login/Login';
import Home from "./components/home/Home";
// import HomeWithoutSplash from "./components/home/Home";
// import SidebarBottom from "./components/home/SidebarBottom";
import Header from './components/header/Header';
import Footer from "./components/footer/Footer";
import RedeemHeader from "./components/redeem/RedeemHeader";
import RedeemBody from "./components/redeem/RedeemBody";
import SavedVideos from "./components/savedVideos/SavedVideos";
import Categories from "./components/savedVideos/Categories";
import Profile from "./components/profile/Profile";
import QuestionTime from "./components/question/QuestionTime";
import Rewards from "./components/reward/Rewards";
import ThankYou from './components/redeem/ThankYou';
import ProtectedRoutes from './components/Auth/Protected';
import WatchSaved from './components/savedVideos/watchSaved';
import WatchSharedVideo from './components/SharedVideo/WatchShareVideo';
import EditProfile from './components/profile/EditProfile';
import Unsub from './components/Unsubscribe/Unsub';
import "./TimeRecorder/TimeRecorder";
// import { useEffect } from 'react';

// const titles = {
//   '/home': 'Home | Ding',
//   '/login': 'Login | Ding',
//   '/redeem,': 'Redeem | Ding',
//   '/profile,': 'Profile | Ding',
//   '/saved,': 'Saved Videos | Ding',
//   '/trivia,': 'Trivia | Ding',
//   '/rewards,': 'Rewards | Ding',
//   '/thankyou,': 'Thank You | Ding',
// }

function App() {
  // const location = useLocation()
  // useEffect(
  //   () => (document.title = titles[location.pathname] ?? 'Ding'),
  //   [location],
  // )

  // useEffect(() => {
  //   // const handleBeforeUnload = (e) => {
  //   //   e.preventDefault();
  //   //   e.returnValue = ''; // This is required for Chrome
  //   //   return ''; // This is required for Firefox
  //   // };
  //   const handleBeforeUnload = (e) => {
  //     const confirmationMessage = 'You have unsaved changes. Are you sure you want to leave?';
  //     e.returnValue = confirmationMessage; // For Chrome
  //     return confirmationMessage; // For Firefox
  //   };

  //   const handleBackButton = () => {
  //     const confirmMessage = 'Are you sure you want to leave the app?';
  //     return confirmMessage;
  //   };
  //   let anim = localStorage.getItem("dv");
  //   if (anim > 2) {
  //     window.addEventListener('beforeunload', handleBeforeUnload);
  //     window.history.pushState(null, null, window.location.href); // Override browser history
  //     window.addEventListener('popstate', handleBackButton);
  //   }


  //   return () => {
  //     if (anim > 2) {
  //       window.removeEventListener('beforeunload', handleBeforeUnload);
  //       window.removeEventListener('popstate', handleBackButton);
  //     }
  //   };
  // }, []);
  return (
    <div>

      <Routes>
        <Route path="/login" element={<><Login /></>}> </Route>
        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<> <Header /><Home showSplash={true} /><Footer /> </>}> </Route>
          <Route path="/home" element={<> <Header /><Home showSplash={true} /><Footer /> </>}> </Route>
          <Route path="/home/landing" element={<> <Header /><Home showSplash={false} /><Footer /> </>}> </Route>
          <Route path="/redeem" element={<> <RedeemHeader /><RedeemBody /><Footer /> </>}> </Route>
          <Route path="/profile" element={<> <Profile /><Footer /> </>}> </Route>
          <Route path="/edit-profile" element={<> <EditProfile /><Footer /> </>}> </Route>
          <Route path="/saved" element={<> <SavedVideos /> <Footer /></>}> </Route>
          <Route path="/categories" element={<> <Categories /> <Footer /></>}> </Route>
          <Route path="/shared/video" element={<> <WatchSharedVideo /><Footer /></>}> </Route>
          <Route path="/saved/watch" element={<> <WatchSaved /><Footer /></>}> </Route>
          <Route path="/trivia" element={<> <QuestionTime /><Footer /> </>}> </Route>
          <Route path="/rewards" element={<><Rewards /><Footer /></>}> </Route>
          <Route path="/thankyou" element={<><ThankYou /><Footer /></>}> </Route>
          <Route path="/unsubscribe" element={<><Unsub /></>}> </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;